import React, { useEffect, useState, useContext  } from "react";
import { useHistory} from 'react-router-dom';
import { AuthContext } from '../../shared/context/auth-context';
import SearchBox from "../../customer/components/SearchBox";
import Scroll from "../../shared/components/navigation/Scroll";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { DashboardAppTableHeaders } from "../components/DashboardAppTableHeaders";
import { DashboardAppMiniTableHeaders } from "../components/DashboardAppTableHeaders";
import { DashboardSpecialOrderTableHeaders } from "../components/DashboardSpecialOrderTableHeaders";
import { DashboardSpecialOrderMiniTableHeaders } from "../components/DashboardSpecialOrderTableHeaders";
import { formatPhoneNumber } from "../../print/page/Print";
import { useWindow } from '../../shared/hooks/window-hook';
import moment from 'moment';
import Table from "../../shared/components/Table/Table";
import "./Dashboard.css";

export const dateHandler = (date) => {
  let dateArray = date.split("-");
  let day = dateArray[2].substring(0, 2);
  let month = dateArray[1];
  let year = dateArray[0];
  return `${month}/${day}/${year}`;
};

const isOrderDue = (order, numberOfDaysToAdd) => {
  let someDate = new Date();
  let result = new Date(someDate.setDate(someDate.getDate() + numberOfDaysToAdd));
  let orderDate = new Date(order.eventDate);
  if (result.valueOf() > orderDate.valueOf()) return true;
  return false;
}

const Dashboard = () => {
  const { width } = useWindow();
  const auth = useContext(AuthContext);
  const [loadedAppointments, setLoadedAppointments] = useState([]);
  const [loadedSpecialOrders, setLoadedSpecialOrders] = useState([]);
  const [searchfieldOrder, setSearchfieldOrder] = useState("");
  const [searchfieldApp, setSearchfieldApp] = useState("");
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const history = useHistory();
  
  useEffect(() => {
    const fetchAppointments = async () => {
      let responseData;
      try {
        responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL+`/appointments/${moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]')}`,
          'GET',
          null,
          {Authorization: 'Bearer '+ auth.token}
        );
        setLoadedAppointments(responseData.appointments.info);
      } catch (err) { }
    };
    fetchAppointments();
  }, [auth.token, sendRequest]);

  useEffect(() => {
    const fetchSpecialOrders = async () =>{
      let responseData;
      try {
        responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL+"/specialOrders",
        "GET",
        null,
        {Authorization: 'Bearer '+ auth.token});
        setLoadedSpecialOrders(responseData.specialOrders);
        
      } catch (err) { }
    };
    fetchSpecialOrders();
  }, [auth.token, sendRequest]);


  const filteredSpecialOrders = loadedSpecialOrders.map((specialOrder) => {
    return ({
      ...specialOrder,
      name: specialOrder.customer.flat()[0] ? specialOrder.customer.flat()[0].name +" "+ specialOrder.customer.flat()[0].lastname : "",
      rowPhone: specialOrder.customer.flat()[0] ? specialOrder.customer.flat()[0].phone : "",
      phone: specialOrder.customer.flat()[0] ? formatPhoneNumber(specialOrder.customer.flat()[0].phone) : "",
      cid: specialOrder.customer.flat()[0] ?   specialOrder.customer.flat()[0].id  : "",
      startDate: dateHandler(specialOrder.startDate),
      eventDate: dateHandler(specialOrder.eventDate),
      arrivalDate: dateHandler(specialOrder.arrivalDate),
      paymentStatus: specialOrder.paymentStatus === "on" ? '✓' : "",
      location: (specialOrder.location).length > 12 ? ((specialOrder.location).slice(0, 10) + "...") : specialOrder.location,
      archive: specialOrder.archive ? "true" : "false"
    }
    );
  }).filter( specialOrder => {
    return (  
      (specialOrder.archive === "false" &&  isOrderDue(specialOrder, 15)) && (
      specialOrder.orderNumber.toLowerCase().includes(searchfieldOrder.toLowerCase())  ||
      specialOrder.style.toLowerCase().includes(searchfieldOrder.toLowerCase())  ||
      specialOrder.company.toLowerCase().includes(searchfieldOrder.toLowerCase())  ||
      specialOrder.name.toLowerCase().includes(searchfieldOrder.toLowerCase())  ||
      String(specialOrder.phone).includes(searchfieldOrder) ||
      specialOrder.eventDate.includes(searchfieldOrder.toLowerCase())  ||
      specialOrder.location.toLowerCase().includes(searchfieldOrder.toLowerCase())  ||
      specialOrder.arrivalDate.includes(searchfieldOrder.toLowerCase())))
    });

  const sortSpecialOrders = filteredSpecialOrders.sort((a, b) => {
    if (new Date(a.eventDate) === new Date(b.eventDate)) return 0;
    return new Date(a.eventDate) > new Date(b.eventDate) ? 1 : -1;
  });

  const filteredAppointments = loadedAppointments.filter((appointment) => {
    return (
      appointment.customer && (
        appointment.time.includes(searchfieldApp.toLowerCase()) ||
        appointment.customer.toLowerCase().includes(searchfieldApp.toLowerCase()) ||
        appointment.type.toLowerCase().includes(searchfieldApp.toLowerCase()) ||
        appointment.phone.toLowerCase().includes(searchfieldApp.toLowerCase()) 
      )
    );
  }).map((appointment) => {
    return({
      ...appointment,
      date: moment(new Date()).format('YYYY-MM-DD'),
      phone: formatPhoneNumber(appointment.phone)
    })
  })


  const onAppSearchChange = (event) => {
    setSearchfieldApp(event.target.value);
  };

  const onOrderSearchChange = (event) => {
    setSearchfieldOrder(event.target.value);
  };

  const onclickSPTable = (id) => {
    history.push('/specialOrders/' + String(id))
  }


  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {isLoading && (
        <div className="center">
          <LoadingSpinner />
        </div>
      )}
      <div className={width > 800  ? "dashboard-table-app" : ""}>
        <div className="tc">
          <div style={{ display: "inline-block" }} >
            <h2 className="dashboard-title-app">APPOINTMENTS</h2>
            <SearchBox searchChange={onAppSearchChange} className="mobile-search"/>
          </div>
        </div>
        <Scroll>
          {!isLoading && filteredAppointments && (
            <Table
              headers={width < 800 ? DashboardAppMiniTableHeaders : DashboardAppTableHeaders}
              content={filteredAppointments}
              onclick={() => history.push(`/appointments/${(moment(new Date()).format('YYYY-MM-DD[T00:00:00.000Z]'))}`)}
            />
          )}
        </Scroll>
      </div>
      <div className="dashboard-tables-order">
        <div className="tc">
          <div style={{ display: "inline-block" }}>
            <h2 className="dashboard-title-order">SPECIAL ORDERS</h2>
            <SearchBox searchChange={onOrderSearchChange} />
          </div>
        </div>
        <Scroll>
          {!isLoading && sortSpecialOrders && (
            <Table
              headers={width < 800 ? DashboardSpecialOrderMiniTableHeaders :DashboardSpecialOrderTableHeaders}
              content={sortSpecialOrders}
              onclick={onclickSPTable}
            />            
          )}
        </Scroll>
      </div>
    </React.Fragment>
  );
};
export default Dashboard;
